<template>
  <div class="bindPhone">
    <div class="phoneGoback">

    </div>
    <div class="phoneTitle">
      <p>
        绑定手机
      </p>
      <p>
        为了您的账户安全，请绑定手机号
      </p>
    </div>
    <div class="phoneEnter">
      <div class="phoneInp">
        <div class="qu">
          +86
        </div>
        <div class="inp">
          <input type="text" @input="phoneChange" placeholder="请输入手机号" v-model="phone">
          <img class="delete" v-if="phone!=''" @click="deletePhone" src="../../assets/images/dele.png" alt="">
        </div>
      </div>
      <div class="verInp">
        <input type="text" placeholder="请输入手机验证码" v-model="ver">
        <button @click="startCountdown" :disabled="isCounting" :class="isCounting?'disBtn':'noBtn'">
          {{ isCounting ? `${countdown}秒重新获取` : '获取验证码' }}
        </button>
      </div>
      <p v-if="phoneerror" class="tip">手机号输入不正确，请重新输入</p>
    </div>
    <div class="btn">
      <button @click="phoneOk">完成</button>
    </div>
  </div>
</template>

<script>
import http from '../../util/gaeaApiConfig'

export default {
  data () {
    return {
      phone: '',
      ver: '',
      countdown: 60,
      isCounting: false,
      phoneerror: false,
    }
  },
  methods: {
    deletePhone () {
      this.phone = ''
    },
    phoneChange () {
      console.log('111')
      const regex = /^1[3456789]\d{9}$/
      if (regex.test(this.phone)) {
        this.phoneerror = false
      } else {
        this.phoneerror = true
      }
    },
    startCountdown () {
      if (this.isCounting) {
        return // 如果正在倒计时，则直接返回
      }
      this.isCounting = true
      let data = {
        phone: this.phone,
        type: 'bind_mobile',
        area_code: '86',
        platform: 'h5',
      }
      http.post('sms_code', data)
      const timer = setInterval(() => {
        this.countdown--
        if (this.countdown === 0) {
          clearInterval(timer)
          this.isCounting = false
          this.countdown = 60
        }
      }, 1000)
    },
    phoneOk () {
      const regex = /^1[3456789]\d{9}$/
      if (regex.test(this.phone) && this.ver.length == 6) {
        let data = {
          unionid: this.$route.query.unionid,
          openid: this.$route.query.openid,
          phone: this.phone,
          sms_code: this.ver,
          udid: 'h5',
          type: 'wx',
          area_code: '86',
          terminal: 'h5',
          need_verify: '1',
          platform_type: '1',
        }
        http.post('users/bind', data).then(res => {
          if (res.data.status_code != 200) {
            alert(res.data.msg)
          } else {
            localStorage.setItem('user_id', res.data.data.user_id)
            localStorage.setItem(
              'refresh_token',
              res.data.data.refresh_token
            )
            localStorage.setItem(
              'token',
              res.data.data.access_token
            )
            this.$router.push({
              path: '/prescriptionlist',
              query: {
                diagnosis_prescription_id: this.$route.query.diagnosis_prescription_id,
                Confirmtype: true,
              }
            })
            setTimeout(() => {
              if (location.href.indexOf('#') == -1) {
                //在当前页面地址加入"#"，使下次不再进入此判断
                location.href = location.href + '#'
                location.reload()
              }
            }, 1000)
            this.show_phone = false
          }
        })
      } else {
        alert('手机号或验证码输入错误')
        return false
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.bindPhone {
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;

  .phoneGoback {
    height: 40px;
  }

  .phoneTitle {
    margin-top: 24px;

    p:nth-child(1) {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }

    p:nth-child(2) {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

  .phoneEnter {
    width: 100%;
    margin-top: 20px;

    .phoneInp {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ccc;

      .qu {
        width: 48px;
        height: 32px;
        background: #EEEEEE;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .inp {
        flex: 1;
        height: 50px;
        position: relative;

        .delete {
          width: 16px;
          height: 16px;
          position: absolute;
          right: 0;
          top: 20px;
        }

        input {
          width: 100%;
          height: 100%;
          background: none;
          border: none;
        }
      }
    }

    .verInp {
      width: 100%;
      margin-top: 10px;
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ccc;

      input {
        flex: 1;
        height: 50px;
        border: none;
        background: none;
      }

      .disBtn {
        width: 110px;
        height: 32px;
        background: #AC4B38;
        opacity: 0.4;
        border-radius: 8px;
        color: #fff;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }

      .noBtn {
        width: 110px;
        height: 32px;
        background: #AC4B38;
        border-radius: 8px;
        color: #fff;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }

    .tip {
      margin-top: 10px;
      font-size: 14px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #F95B51;
    }
  }

  .btn {
    height: 50px;
    margin-top: 40px;

    button {
      width: 100%;
      height: 100%;
      background: #AC4B38;
      border-radius: 12px;
      color: #fff;
      font-size: 18px;
      font-family: PingFang-SC-Bold, PingFang-SC;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/bindPhone.vue